import React from 'react';
import {TermStatus} from '../../scaffold';
import {Tag} from 'antd';

export default function TermStatusTag(props: {status: TermStatus}) {
  if (props.status === TermStatus.未开始) return <Tag>未开始</Tag>;
  if (props.status === TermStatus.进行中) return <Tag color={'green'}>进行中</Tag>;
  return <Tag color={'red'}>已结束</Tag>;
}
